import React, { useEffect } from "react"
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

function FormDialog(props) {
    const [open, setOpen] = React.useState(false);
    const { op, setOp, title, func, fields } = props

    useEffect(() => {
        setOpen(op)
    }, [op])


    const handleClose = () => {
        setOpen(false);
        setOp(false)
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {fields.map(el => (
                        < TextField
                            key={el.id}
                            margin="dense"
                            id={el.id}
                            label={el.label}
                            type={el.type}
                            fullWidth
                            value={el.value}
                            onChange={(e) => { el.func(e.target.value) }}
                        />
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Չեղարկել
          </Button>
                    <Button onClick={func} color="primary">
                        Հաստատել
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog